module.exports = {
    "areg": {
        "VIP形容内容": "عضوية الVIP هي خدمة مميزة حصرية مُقدمة خصيصًا لك، استمتع بخدمات مُتعددة من السلطات الاستثنائية والمركبات الحصرية لدخول غرفة البث، بالإضافة إلى إرسال رسائل خاصة مجانًا، واكتشف المزيد من المميزات الأُخرى  ",
        "VIP是什么": "ماهي عضوية الVIP؟",
        "VIP特权": "إمتيازات عضوية ال VIP",
        "VIP特权内容": "1. حل مشاكل الحسابات المُميزة، يُمكن أن تحل سريعًا عن طريق خدمة \"الأعضاء المُميزين\". @@@@ 2. ستستمتع بخدمات مميزة من خدمة العملاء الذهبية، فهي خدمة عملاء مُخصصة لك أنت. @@@@ 3. مركبات مميزة لدخول غرفة البث المباشر مُخصصة للVIP. @@@@ إرسال رسائل خاصة مجانا.",
        "VIP等级": "مستويات عضوية ال VIP",
        "VIP等级及对应充值额度": "عضوية ال VIP وما يقابلها  من رصيد الشحن",
        "VIP获得方式": "طرق الحصول على عضوية ال VIP",
        "VIP获得方式内容": "1. طبقا لاختلاف توقيت الدول لكل مُستخدم،  أول يوم من كل شهر عندما يصل رصيد شحن الماس إلى الرصيد الذي يقابل عضوية الVIP عندها يُمكنك الاستمتاع بالعضوية وإمتيازاتها. @@@@ 2. الشحن هو الطريقة الوحيدة للحصول على عضوية الVIP.",
        "VIP规则": "قواعد عضوية ال VIP",
        "VIP规则内容": "1. لكي يحافظ المُستخدم على عضوية الVIP الخاصة به لكل شهر، لابد أن يحافظ على رصيد الشحن المحدد لكل شهر، وإلا ستنخفض عضوية الVIP الشهر المقبل مستوى واحد أقل. @@@@ 2. يحق لكل مستخدمي الVIP القيام بمنع المستخدمين الغير مهذبين من التحدث وطردهم من غرفة البث المباشر.",
        "banner": "لا تفوت مُتعة تجربة مميزات عضوية الVIP الخارقة في النسخة الجديدة من التطبيق",
        "保级要求(U钻)": "متطلبات الحفاظ على العضوية (بالماس)",
        "充值要求(U钻)": "متطلبات الشحن (بالماس)",
        "提示内容": "إن مميزات عضوية الVIP مازالت في فترة التجربة، لذا وجب التنبيه على التالي: إذا واجهت أي مشكلة، يُرجى التواصل مع خدمة العملاء. ونأسف لحدوث أي مشكلة قد تواجهك، شكرًا  !",
        "温馨提示": "تنبيه هام",
        "禁言次数": "عدد مرات الحظر من التحدث",
        "踢人次数": "عدد مرات الطرد",
        "页面标题": "التعريف بعضوية ال VIP في UpLive للبث المباشر",
        "页面标题马甲包": "التعريف بعضوية ال VIP في  للبث المباشر"
    },
    "enus": {
        "VIP形容内容": "VIP is a distinguish status with a series of privileges like special animated swagger, free whispering, etc.",
        "VIP是什么": "What is VIP",
        "VIP特权": "VIP Privileges",
        "VIP特权内容": "1. Exclusive VIP customer service to resolve any issues quickly @@@@ 2. One-to-one customer service specialist for each VIP user @@@@ 3. VIP special effects when entering a broadcast room @@@@ 4. Whisper is free",
        "VIP等级": "VIP Level",
        "VIP等级及对应充值额度": "VIP Level and diamonds required",
        "VIP获得方式": "How to obtain VIP status",
        "VIP获得方式内容": "1. You will be rewarded VIP status of tier @@@@ based on the diamonds purchased within a calendar month 2. Purchasing diamonds is the only way to obtain and level up VIP status to ",
        "VIP规则": "VIP Rules",
        "VIP规则内容": "1. After a user has obtained VIP status, a certain amount of diamond purchases within the calendar month is required to maintain the status for next month @@@@ 2. VIP users can perform actions on non-VIP users such as silencing them and banning them from a live stream",
        "banner": "You got an invitation to test new VIP function!\n03/02/2017",
        "保级要求(U钻)": "Diamonds required to maintain level",
        "充值要求(U钻)": "Diamonds required to obtain level",
        "提示内容": "Since the VIP function is under beta testing, if you run into any problem, feel free contact to our customer service. We apologise for the inconvenience that this may cause.",
        "温馨提示": "Warning",
        "禁言次数": "Muted # users",
        "踢人次数": "Banned # users",
        "页面标题": "UpLive VIP Description",
        "页面标题马甲包": "VIP Description"
    },
    "jajp": {
        "VIP形容内容": "VIPになるとスペシャルカスタマーサポートを受けられます。更に、特別な入場アニメーションや無料チャットを使えるようになります",
        "VIP是什么": "VIPとは",
        "VIP特权": "VIPサービス",
        "VIP特权内容": "1．「会員カスタマーサポート」・・お困りの時も迅速に対応します！\n@@@@2．「VIP入場アニメーション」・・あなたの大きな存在をアピールしましょう！ \n@@@@3．「チャット無料」・・お気に入りのキャストとのコミュニケーションを楽しんでください！ ",
        "VIP等级": "VIPレベル",
        "VIP等级及对应充值额度": "VIPレベル別ダイヤ購入額",
        "VIP获得方式": "VIPについて",
        "VIP获得方式内容": "1．毎月一定のダイヤをご購入いただきますと、VIPになることができます\n@@@@2．VIPレベルに応じて、より充実したVIPサービスをご提供します\n",
        "VIP规则": "VIPルール",
        "VIP规则内容": "1. 今月のチャージ結果が、VIPレベル継続基準に達すると、自動的に1ヶ月間延長されます。VIPレベル継続基準に達していない場合、来月のVIPレベルが1下がります。\n@@@@2. VIPは一般ユーザに発言制限や配信から退出させることが可能です。",
        "banner": "VIP機能（ベータ版）を体験して下さい！\n新しい機能満載、お試しください！\n2017年3月2日",
        "保级要求(U钻)": "継続基準",
        "充值要求(U钻)": "昇格基準",
        "提示内容": "VIP機能のテスト期間中に問題がある場合は、カスタマーサービスへご連絡下さい。ご協力のほど、よろしくお願いします",
        "温馨提示": "お知らせ",
        "禁言次数": "発言制限",
        "踢人次数": "ライブ配信退出",
        "页面标题": "UpLive VIPサービスのご紹介",
        "页面标题马甲包": "VIPサービスのご紹介"
    },
    "vivn": {
        "VIP形容内容": " VIP là tính năng giúp bạn có thể nhận được sự chăm sóc đặc biệt, tận hưởng quyền lợi đặc biệt, hiệu ứng cực độc, tin nhắn PM miễn phí và nhiều ưu đãi khác.",
        "VIP是什么": "VIP là gì?",
        "VIP特权": "Đặc quyền VIP",
        "VIP特权内容": "1. Luôn nhận được sự ưu tiên khi có vấn đề cần giải quyết@@@@2. Tận hưởng quyền lợi ưu đãi và tốt nhất từ bộ phận chăm sóc khách hàng của Uplive@@@@3. Hiệu ứng VIP đặc biệt.@@@@4. Tin nhắn thì thầm hoàn toàn miễn phí.",
        "VIP等级": "Cấp VIP",
        "VIP等级及对应充值额度": "Cấp VIP và số tiền cần nạp",
        "VIP获得方式": "Cách để đạt VIP ",
        "VIP获得方式内容": "1. Cứ mỗi tháng, user nạp đến định mức nhất định sẽ nhận được đặc quyền VIP theo số tiền đã nạp @@@@2. Cấp VIP có thể được nâng lên bằng cách nạp tiền",
        "VIP规则": "Yêu cầu VIP",
        "VIP规则内容": "1. User đã đạt đủ tiêu chuẩn nhận VIP, cần phải đảm bảo chỉ tiêu nạp kim cương mỗi tháng để giữ được danh hiệu, nếu không tháng tiếp theo sẽ bị xuống cấp.@@@@2. VIP user có thể silence và kick những user thường ra khỏi phòng.",
        "banner": "VIP (beta) Bản cập nhật mới với rất nhiều tính năng hấp dẫn\nĐừng bỏ lỡ nhé!\n02/03/2017 ",
        "保级要求(U钻)": "Yêu cầu để giữ cấp (kim cương)",
        "充值要求(U钻)": "Số tiền cần nạp (kim cương)",
        "提示内容": "Nếu gặp bất cứ vấn đề khó khăn trong thời gian thử nghiệm tính năng VIP, hãy liên hệ bộ phận CS để nhận sự giúp đỡ ngay nhé! ",
        "温馨提示": "Lưu ý",
        "禁言次数": "Số lần cấm chat",
        "踢人次数": "Số lần kick user ",
        "页面标题": "Giới thiệu tính năng Uplive VIP",
        "页面标题马甲包": "Giới thiệu tính năng VIP"
    },
    "zhcn": {
        "VIP形容内容": "   VIP是专享服务身份的象征，享有专属权限、入场特效、免费悄悄话等服务。",
        "VIP是什么": "VIP是什么",
        "VIP特权": "VIP特权",
        "VIP特权内容": "1. 专享账号申诉通道，能快捷解决“尊贵会员”问题@@@@2.享受专属黄金会员客服通道，专业一对一的VIP客服服务@@@@3. VIP专享入场特效@@@@4. 悄悄话免费",
        "VIP等级": "VIP等级",
        "VIP等级及对应充值额度": "VIP等级及对应充值额度",
        "VIP获得方式": "VIP获得方式",
        "VIP获得方式内容": "1. 按照用户所在时区的1个自然月内，充值U钻达到一定额度，即可享该额度对应的VIP等级及特权@@@@2. 充值是获得和提升VIP等级的唯一途径",
        "VIP规则": "VIP规则",
        "VIP规则内容": "1. 用户成为VIP当月起，需要保证每月一定充值额度保级，否则下个自然月VIP等级将会降低1级@@@@2. VIP用户享有对普通用户禁言、移除直播间操作权限",
        "banner": "VIP（公测）功能新体验  重磅来\n袭不容错过\n2017年3月2日",
        "保级要求(U钻)": "保级要求(U钻)",
        "充值要求(U钻)": "充值要求(U钻)",
        "提示内容": "VIP功能因在公测期间，如出现任何问题请及时联系客服。给您带来的麻烦，我们在此表示最诚挚的歉意！",
        "洋妞直播VIP简介": "洋妞直播VIP简介",
        "温馨提示": " 温馨提示",
        "禁言次数": "禁言次数",
        "踢人次数": "踢人次数",
        "页面标题": "Up直播VIP简介",
        "页面标题马甲包": "VIP简介"
    },
    "zhhk": {
        "VIP形容内容": "VIP是專屬服務身份象徵，享有專屬權限、入場特效、免費悄悄話等服務。",
        "VIP是什么": "VIP是什麼",
        "VIP特权": "VIP特權",
        "VIP特权内容": "1. 專屬帳號申訴通道，能迅速解決\"尊貴會員\"問題\n@@@@2. 享受專屬黃金會員客服通道，專業一對一的VIP客服服務\n@@@@3. VIP專享入場特效\n@@@@4. 悄悄話免費",
        "VIP等级": "VIP等級",
        "VIP等级及对应充值额度": "VIP等級及對應增值額度",
        "VIP获得方式": "VIP獲得方式",
        "VIP获得方式内容": "1. 按照用戶所在地區的1個月內，增值U鑽達到一定額度，即該額度對應的VIP等級及特權\n@@@@2. 增值是獲得和提升VIP等級的唯一方法",
        "VIP规则": "VIP規則",
        "VIP规则内容": "1. 用戶成為VIP當月起，需要保證每個月一定增值額度保級，否則下個自然月VIP等級將會降低1級\n@@@@2. VIP用戶擁有對普通用戶進行禁言或者移除直播間的操作權限",
        "banner": "VIP（公測）功能新體驗  重磅來襲不容錯過  2017年3月2日",
        "保级要求(U钻)": "保級要求（U鑚）",
        "充值要求(U钻)": "增值要求（U鑚）",
        "提示内容": "VIP功能因在公測期間，如出現任何問題請及時聯繫客服。給您帶來的麻煩，我們在此表示最誠摯的歉意！",
        "温馨提示": "溫馨提示",
        "禁言次数": "禁言次數",
        "踢人次数": "踢人次數",
        "页面标题": "Up直播VIP簡介",
        "页面标题马甲包": "VIP簡介"
    },
    "zhtw": {
        "VIP形容内容": "VIP是專屬服務身份象徵，享有專屬權限、入場特效、免費悄悄話等服務。",
        "VIP是什么": "VIP是什麼",
        "VIP特权": "VIP特權",
        "VIP特权内容": "1.專屬帳號申訴通道，能盡速解決\"尊貴會員\"問題\n@@@@2.享受專屬黃金會員客服通道，專業一對一的VIP客服服務\n@@@@3.VIP入場特效(公測中暫無特效)\n@@@@4.悄悄話免費",
        "VIP等级": "VIP等級",
        "VIP等级及对应充值额度": "VIP等級及對應儲值額度",
        "VIP获得方式": "VIP獲得方式",
        "VIP获得方式内容": "1. 按照用戶所在地區的1個月內，儲值U鑽達到一定額度，即該額度對應的VIP等級及特權\n@@@@2. 儲值是獲得和提升VIP等級的唯一方法",
        "VIP规则": "VIP規則",
        "VIP规则内容": "1.用戶成為VIP當月份起，到下個月期間需儲值一定額度維持等級，否則在第3個月初VIP等級將會降級。\n@@@@2.舉例1：1/1儲值達到VIP1資格，您將在2/1~2/28期間有續等時間，在續等時間未達到60%儲值金額，3/1起將降級為無VIP資格。\n@@@@3.舉例2：1/15儲值達到VIP1資格，您將在2/1~2/28期間有續等時間，在續等時間未達到60%儲值金額，3/1起將降級為無VIP資格。\n@@@@4.舉例3：1/31儲值達到VIP2資格，您將在2/1~2/28期間有續等時間，在續等時間未達到60%儲值金額，3/1起將降級為VIP1。\n@@@@5.儲值要求金額與續等要求金額詳見\"VIP等級及對應儲值額度\"。\n@@@@6.VIP用戶可以對普通用戶進行禁言和移除直播間操作。\n",
        "banner": "VIP(公測)功能新體驗 重磅來襲不容錯過\n2017年3月2日",
        "保级要求(U钻)": "續等要求(U鑽)",
        "充值要求(U钻)": "儲值要求(U鑽)",
        "提示内容": "VIP功能因在公測期間，如出現任何問題請即時聯繫客服。給您帶來麻煩，我們在此表示最誠摯的歉意。",
        "洋妞直播VIP简介": "洋鈕直播VIP簡介",
        "温馨提示": "溫馨提示",
        "禁言次数": "禁言次數(每日0點重置)",
        "踢人次数": "踢人次數(每日0點重置)",
        "页面标题": "Up直播VIP簡介",
        "页面标题马甲包": "VIP簡介"
    }
}


// WEBPACK FOOTER //
// ./js/lang/pack.js